import { motion, useReducedMotion } from 'framer-motion';
import Breadcrumbs from './Breadcrumbs';

const PageHero = ({ overline, title, intro, image, breadcrumbs, compact = false }) => {
  const reduce = useReducedMotion();
  return (
    <section data-testid="page-hero" className={`relative overflow-hidden border-b border-line bg-paper ${compact ? 'pt-28 md:pt-32' : 'pt-32 md:pt-40'}`}>
      <div className="container-site pb-14 md:pb-20">
        <div className={`grid items-end gap-10 ${image ? 'lg:grid-cols-12' : ''}`}>
          <div className={image ? 'lg:col-span-7' : 'max-w-3xl'}>
            {breadcrumbs && <Breadcrumbs items={breadcrumbs} />}
            {overline && (
              <motion.p
                initial={reduce ? false : { opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.6 }}
                className="overline-label"
              >
                {overline}
              </motion.p>
            )}
            <span className="mask-line mt-3">
              <motion.h1
                initial={reduce ? false : { y: '110%' }}
                animate={reduce ? {} : { y: 0 }}
                transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                className="block font-serif text-4xl font-medium leading-[1.02] tracking-tight text-ink sm:text-5xl lg:text-6xl"
              >
                {title}
              </motion.h1>
            </span>
            {intro && (
              <motion.p
                initial={reduce ? false : { opacity: 0, y: 14 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3, duration: 0.7 }}
                className="mt-6 max-w-2xl text-lg leading-relaxed text-muted2"
              >
                {intro}
              </motion.p>
            )}
          </div>
          {image && (
            <motion.div
              initial={reduce ? false : { opacity: 0, scale: 0.97 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.2, duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
              className="hidden lg:col-span-5 lg:block"
            >
              <div className="img-frame aspect-[4/3] border border-line p-2.5">
                <img src={image.src} alt={image.alt} />
              </div>
            </motion.div>
          )}
        </div>
      </div>
    </section>
  );
};

export default PageHero;
